import { createContext } from "react";
import PageStore from './store'

const store = new PageStore();
const PageStoreContext = createContext<PageStore>(store);
export default PageStoreContext;
